/**
 * Institution types for CEO / org-admin Institution setup.
 * Keep in sync with functions/src/fde/institutionTypes.js
 */
export const INSTITUTION_TYPES = [
  { value: "health-system", label: "Health system" },
  { value: "independent-hospital", label: "Independent hospital" },
  {
    value: "freestanding-clinic",
    label: "Freestanding Clinic / Urgent Care facility",
  },
];

export const INSTITUTION_TYPE_VALUES = INSTITUTION_TYPES.map((t) => t.value);

export function isValidInstitutionType(value) {
  return INSTITUTION_TYPE_VALUES.includes(value);
}
